// extracted by mini-css-extract-plugin
module.exports = {"dashboard-page":"styles_dashboard-page__2iynh","body":"styles_body__P71bH","content":"styles_content__fewtM","projectGallery":"styles_projectGallery__3OgrF"};